module.exports = __webpack_public_path__ + "static/media/forever_tricolour_10.1fc6dfc9.jpg";